import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setDocumentFilter } from '../actions';
import '../global';

class CategoryFilter extends Component {

	filterDocumentType( event ) {
		this.props.setDocumentFilter( 'category', event.target.value );
	}

	getDocumentFilterValue() {
		return (typeof this.props.documentFilter.category !== 'undefined'
		       ) ? this.props.documentFilter.category : '';
	}

	getCategoryOptions() {
		const categoryArrays = [
			'Agenda', 'Documentation', 'Draft', 'Final Version', 'Letter',
			'Minutes', 'Miscellaneous', 'Outline', 'Presentation', 'White Paper'
		];
		const categoryOptions = categoryArrays.map( category =>
			                                            <option value={ category }>{ category }</option> );

		categoryOptions.unshift( <option value=''>All Categories</option> );
		return categoryOptions;

	}

	render() {
		//todo should make this dynamic at some point.
		return (<div className="meeting-committee-options col-xs-12 col-md-3">
				<select className="form-control" name="document-category-filter" onChange={ this.filterDocumentType.bind( this ) } value={ this.getDocumentFilterValue() }>
					{ this.getCategoryOptions() }
				</select>
			</div>
		);
	}

}

function mapStateToProps( { documentFilter } ) {
	return { documentFilter };
}

export default connect( mapStateToProps, { setDocumentFilter } )( CategoryFilter );

